import dynamic from 'next/dynamic'
import { ComponentPropsWithoutRef, ReactNode } from 'react'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogPaper
} from '@/modules/components/ui/dialog'
import Image from 'next/image'
import { DocumentIcon } from '~shared/icons/document'

const LeadForm = dynamic(() => import('./lead-form').then(m => m.LeadForm), {
  ssr: false,
  loading: () => null
})

type Props = {
  formanaim?: string
  pdf?: {
    name: string
    url: string
  }[]
} & ComponentPropsWithoutRef<typeof Dialog>

export const LeadFormPDFDialog = ({
  formanaim,
  open,
  pdf,
  onOpenChange,
  ...rest
}: Props) => {
  return (
    <Dialog {...rest} open={open} onOpenChange={onOpenChange}>
      <DialogContent className=''>
        <DialogClose />
        <DialogPaper className='box-border w-full md:w-[704px] relative overflow-hidden'>
          <h2 className='font-medium leading-[120%] text-2xl md:text-3xl lg:text-4xl max-w-[440px]'>
            Получите подборку полезных материалов
          </h2>
          {!!pdf?.length && (
            <div className='mt-7 flex flex-col gap-4 mb-[28px]'>
              {pdf.map(
                ({ name }, idx) =>
                  name && (
                    <div
                      key={`${name}-${idx}`}
                      className='flex items-center gap-2 text-white'>
                      <DocumentIcon className='w-[24px] h-[24px]' />
                      <span className='text-sm text-[#8B8B8B]'>{name}</span>
                    </div>
                  )
              )}
            </div>
          )}
          {open && (
            <LeadForm
              formanaim={formanaim}
              pdfData={pdf}
              className='w-full sizin relative z-10'
              buttonText='Получить полезные материалы'
              inputClassName='bg-secondary box-border'
              onSuccess={() => onOpenChange?.(false)}
            />
          )}
          <Image
            alt='flower mitu'
            src='/assets/imgs/journal-page/books.png'
            width={200}
            height={200}
            className='absolute hidden md:block top-0 right-0 z-0 max-w-[250px]'
          />
        </DialogPaper>
      </DialogContent>
    </Dialog>
  )
}
